import { render } from "./AdminArea.vue?vue&type=template&id=90ad53e2&scoped=true"
import script from "./AdminArea.vue?vue&type=script&lang=js"
export * from "./AdminArea.vue?vue&type=script&lang=js"

import "./AdminArea.vue?vue&type=style&index=0&id=90ad53e2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90ad53e2"]])

export default __exports__